module.exports = __webpack_public_path__ + "static/CHAP-logo-3e3e031d1ff5ea8b83822b5beef2240b.png";